export default __webpack_public_path__ + "static/media/ISWEC-16.2b69d65c.pdf";